import {useCallback, useState} from "react";

export type ConfirmDeleteOptions = {
    onDelete: () => Promise<unknown>;
    onSuccess?: () => void;
    onError?: (e: unknown) => void;
    autoClose?: boolean;
};

export function useConfirmDelete({
                                     onDelete,
                                     onSuccess,
                                     onError,
                                     autoClose = true,
                                 }: ConfirmDeleteOptions) {
    const [open, setOpen] = useState(false);
    const [pending, setPending] = useState(false);

    const openDialog = useCallback(() => setOpen(true), []);
    const closeDialog = useCallback(() => setOpen(false), []);

    const confirm = useCallback(async () => {
        try {
            setPending(true);
            await onDelete();
            onSuccess?.();
            if (autoClose) setOpen(false);
        } catch (e) {
            onError?.(e);
        } finally {
            setPending(false);
        }
    }, [onDelete, onSuccess, onError, autoClose]);

    return {open, pending, openDialog, closeDialog, confirm};
}
